/* unplugin-vue-components disabled */import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import iMenuHeadTitle from './title';
import { mapState, mapGetters } from 'vuex';
import { getStyle } from 'view-ui-plus/src/utils/assist';
import clickItem from '../mixins/click-item';
import Setting from '@/setting';
// import { on, off } from 'view-ui-plus/src/utils/dom';
// import { throttle } from 'lodash';

export default {
  name: 'iMenuHead',
  components: {
    iMenuHeadTitle: iMenuHeadTitle
  },
  mixins: [clickItem],
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('admin/layout', ['isMobile'])), mapState('admin/menu', ['headerName'])), mapGetters('admin/menu', ['filterHeader'])),
  data: function data() {
    return {
      handleResize: function handleResize() {},
      isMenuLimit: false,
      menuMaxWidth: 0 // 达到这个值后，menu 就显示不下了
    };
  },
  methods: {
    handleGetMenuHeight: function handleGetMenuHeight() {
      var menuWidth = parseInt(getStyle(this.$el, 'width'));
      var $menu = this.$refs.menu;
      if ($menu) {
        var menuHeight = parseInt(getStyle(this.$refs.menu.$el, 'height'));
        if (menuHeight > Setting.headerHeight) {
          if (!this.isMenuLimit) {
            this.menuMaxWidth = menuWidth;
          }
          this.isMenuLimit = true;
        }
      } else if (menuWidth >= this.menuMaxWidth) {
        this.isMenuLimit = false;
      }
    }
  },
  watch: {
    filterHeader: function filterHeader() {
      this.handleGetMenuHeight();
    },
    isMobile: function isMobile() {
      this.handleGetMenuHeight();
    }
  },
  mounted: function mounted() {
    // this.handleResize = throttle(this.handleGetMenuHeight, 100, { leading: false });
    // on(window, 'resize', this.handleResize);
    this.handleGetMenuHeight();
  },
  beforeUnmount: function beforeUnmount() {
    // off(window, 'resize', this.handleResize);
  }
};